import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { createCliente, getApiErrorMessage } from "@/lib/api";

/** Alta rápida: lo primero es el nombre con el que el equipo reconoce al cliente; el resto se completa luego en la ficha. */
export function NuevoClienteDialog({ open, onOpenChange, onCreated, textoBoton = "Crear cliente" }) {
  const [alias, setAlias] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [nif, setNif] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setAlias("");
      setRazonSocial("");
      setNif("");
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!alias.trim() && !razonSocial.trim()) {
      toast.error("Ponle un nombre al cliente");
      return;
    }
    setSaving(true);
    try {
      const cliente = await createCliente({ alias: alias.trim(), razon_social: razonSocial.trim(), nif: nif.trim() });
      onOpenChange(false);
      onCreated?.(cliente);
    } catch (err) {
      toast.error(getApiErrorMessage(err, "No se pudo crear el cliente"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit} className="space-y-4">
          <DialogHeader>
            <DialogTitle>Nuevo cliente</DialogTitle>
            <DialogDescription>Si viene de Zoho, la próxima sincronización lo vinculará por su NIF.</DialogDescription>
          </DialogHeader>
          <div className="space-y-1.5">
            <Label htmlFor="nc-alias">¿Cómo lo llamáis?</Label>
            <Input id="nc-alias" autoFocus value={alias} onChange={(e) => setAlias(e.target.value)} placeholder="Ej. Mir Moments" className="h-11 text-base" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-[1fr_140px] gap-3">
            <div className="space-y-1.5">
              <Label htmlFor="nc-razon" className="text-muted-foreground">Razón social</Label>
              <Input id="nc-razon" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} placeholder="Opcional" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="nc-nif" className="text-muted-foreground">NIF/CIF</Label>
              <Input id="nc-nif" value={nif} onChange={(e) => setNif(e.target.value)} placeholder="Opcional" />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={saving}>
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              {textoBoton}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
